import packageJson from "../../package.json";

// Helper function to convert ImmutableJS serialized data to plain objects
const deserializeImmutable = (data) => {
  if (typeof data === "string") {
    try {
      const parsed = JSON.parse(data);
      if (parsed && parsed.__serializedType__) {
        // It's a serialized Immutable object
        return parsed.data || {};
      }
      return parsed;
    } catch {
      return data;
    }
  }

  if (data && typeof data === "object") {
    if (data.__serializedType__) {
      // It's a serialized Immutable object
      return data.data || {};
    }

    // Recursively convert nested objects
    const result = Array.isArray(data) ? [] : {};
    for (const key in data) {
      result[key] = deserializeImmutable(data[key]);
    }
    return result;
  }

  return data;
};

export const migrations = {
  // Version 2: Clear all state to ensure clean migration from ImmutableJS
  2: (state) => {
    // Clear persisted state completely to start fresh
    return {};
  },
};
